// extracted by mini-css-extract-plugin
module.exports = {"btn-primary":"_styles_btn-primary__3n5HR","inputLabelContainer":"_styles_inputLabelContainer__2gxpm","inputLabel":"_styles_inputLabel__op7oq","error":"_styles_error__18QVb"};